/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { connect } from 'react-redux';

//Components
import SmartMenu from '../index';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { SmartLinkLogo } from '../../components';
import WpAvatar from 'Wpds/components/avatar/WpAvatar';
import { WpButton } from 'Wpds/components/button';

//Selectors
import { getGoogleDriveSignUpUrl } from 'Shared/selectors/smartLinks';

//Helpers
import { FormatF } from 'Shared/helpers';
import { trackClickedConnectApp } from 'Shared/tracking/tracking';
import { DataSourceSlugs } from 'Shared/constants/types';

//Styles
import '../SmartMenu.scss';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  hasGoogleDriveIntegration: boolean;
  googleDriveSignUpUrl: string;
  type?: string;
  logoName?: string;
};

const GoogleSmartMenu = (props: Props) => {
  const { tr } = useTranslation();
  const { hasGoogleDriveIntegration, googleDriveSignUpUrl, type, logoName } = props;
  const renderSmartLinkDetail = smartLinkDetail => {
    const { created_by, created_by_avatar, time_spent, still_syncing } = smartLinkDetail;
    const created_by_initials = created_by
      ? created_by.includes(' ')
        ? created_by.substr(0, 1) + created_by.split(' ')[1].substr(0, 1)
        : created_by.substr(0, 1)
      : '';
    const created_by_display_avatar = created_by_avatar
      ? created_by_avatar
      : { initials: created_by_initials, color: '#57CA8C' };
    const className = 'SmartMenu__content__row';

    return (
      <>
        <div className={className}>
          <div className={`${className}__label`}>{tr('perform.smart_links.google.created_by_label')}</div>
          <div className={`${className}__value`}>
            {created_by && <WpAvatar size="sm" avatar={created_by_display_avatar} />}
            {!created_by && (
              <span className={`${className}__empty-user-icon`}>
                <WpIcon name="user" size="md" />
              </span>
            )}
            <div className={`${className}__value__text`}>{created_by || tr('perform.smart_links.common.unknown')}</div>
          </div>
        </div>
        {!time_spent && still_syncing && <div>{tr('perform.smart_links.google.still_syncing')}</div>}

        {time_spent && <div>{tr('perform.smart_links.google.no_time_spent')}</div>}

        {time_spent && !still_syncing && (
          <div>{tr('perform.smart_links.google.time_spent', String(FormatF('h', time_spent)))}</div>
        )}
        <p />
        <a href={smartLinkDetail.url} target="blank" rel="noopener norefferer">
          {tr('perform.smart_links.google.view_type', type)}
        </a>
      </>
    );
  };

  const handleConnectClick = () => {
    trackClickedConnectApp(DataSourceSlugs.googleDrive);
    window.location.href = googleDriveSignUpUrl;
  };

  const renderEmbedingContent = () => {
    const className = 'SmartMenu__content__button';
    return (
      <>
        <div className={className}>{tr('perform.smart_links.google.connect_prompt')}</div>
        <p />
        <div className={className}>
          <WpButton variant="tertiary" onClick={handleConnectClick} block>
            {tr('perform.smart_links.google.connect_cta')}
          </WpButton>
        </div>
      </>
    );
  };

  const capitalizedName = type
    ? type.substring(0, 1).toLocaleUpperCase() + type.substring(1)
    : tr('perform.smart_links.google.type.document');
  const menuTitle = () => (
    <>
      <SmartLinkLogo src={logoName} />
      {tr('perform.smart_links.google.menu_title', capitalizedName)}
    </>
  );
  const objectName = tr('perform.smart_links.google.object_name', capitalizedName);

  return (
    <SmartMenu
      hasDocumentIntegration={hasGoogleDriveIntegration}
      renderEmbedingContent={renderEmbedingContent}
      renderSmartLinkDetail={renderSmartLinkDetail}
      objectName={objectName}
      menuTitle={menuTitle}
      {...props}
    />
  );
};

const mapStateToProps = state => ({
  hasGoogleDriveIntegration: state.user.hasGoogleDriveIntegration,
  googleDriveSignUpUrl: getGoogleDriveSignUpUrl(state),
});

export default connect(mapStateToProps, null)(GoogleSmartMenu);
